import { useMemo } from 'react';
import { useNodes } from '@xyflow/react';
import type { UUIDType } from '../../../../common/utils';
import type { AlgorithmJoinsAndMappingsGraphNodeTypeName } from '../schema/types';

export const useNodeIndex = (
  id: UUIDType,
  nodeType?: AlgorithmJoinsAndMappingsGraphNodeTypeName,
) => {
  const nodes = useNodes();
  return useMemo(
    () =>
      (nodeType
        ? nodes.filter((node) => node.type === nodeType)
        : nodes
      ).findIndex((node) => node.id === id),
    [id, nodes, nodeType],
  );
};
